var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcEmailError = function SvgIcEmailError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    viewBox: "0 0 24 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 15,
    x: 0.5,
    y: 0.5,
    fill: "#F1DEDE",
    stroke: "#EED3D7",
    rx: 3
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#B94A48",
    points: "6.707 6 8.475 7.768 7.768 8.475 6 6.707 4.232 8.475 3.525 7.768 5.293 6 3.525 4.232 4.232 3.525 6 5.293 7.768 3.525 8.475 4.232",
    transform: "translate(6 2)"
  }))));
};
export default SvgIcEmailError;